import { DistrictList } from "../staticInfo/state";
import { BinGroup, BinHisoryList, BinList } from "./state";

export function InitBinListAction(binListState: BinList[]) {
    return {
        type: "@@InitBinListState/InitBinListAction" as const,
        binListState,
    };
}

export function initBinGroupListAction(BinGroupList:BinGroup[]){
    return {
        type: "@@InitBinListState/initBinGroupListAction" as const,
        BinGroupList,
    };
}

export function InitBinDetailAction(binDetail: BinList) {
    return {
        type: "@@InitBinListState/InitBinDetailAction" as const,
        binDetail,
    };
}

export function ChangeBinNameAction(name: string) {
    return {
        type: "@@InitBinListState/ChangeBinNameAction" as const,
        name,
    };
}

export function ChangeBinEngNameAction(name: string) {
    return {
        type: "@@InitBinListState/ChangeBinEngNameAction" as const,
        name,
    };
}

export function ChangeBinEmailAction(email: string) {
    return {
        type: "@@InitBinListState/ChangeBinEmailAction" as const,
        email,
    };
}

export function ChangeBinContactPersonAction(contact_person: string) {
    return {
        type: "@@InitBinListState/ChangeBinContactPersonAction" as const,
        contact_person,
    };
}

export function ChangeBincCodeAction(code: string) {
    return {
        type: "@@InitBinListState/ChangeBincCodeAction" as const,
        code,
    };
}

export function ChangeBincLatAction(lat: string) {
    return {
        type: "@@InitBinListState/ChangeBincLatAction" as const,
        lat,
    };
}

export function ChangeBincLonAction(lon: string) {
    return {
        type: "@@InitBinListState/ChangeBincLonAction" as const,
        lon,
    };
}

export function ChangeBinRemarkAction(remark: string) {
    return {
        type: "@@InitBinListState/ChangeBinRemarkAction" as const,
        remark,
    };
}

export function ChangeBinContractAction(contract_id: string) {
    return {
        type: "@@InitBinListState/ChangeBinContractAction" as const,
        contract_id,
    };
}

export function ChangeDistrictIdAction(data: DistrictList) {
    return {
        type: "@@InitBinListState/ChangeDistrictIdAction" as const,
        data,
    };
}

export function ClearSelectedBinAction() {
    return {
        type: "@@InitBinListState/ClearSelectedBinAction" as const,
    };
}

export function ChangeBinTypeAction(bin_type_id: string) {
    return {
        type: "@@InitBinListState/ChangeBinTypeAction" as const,
        bin_type_id,
    };
}

export function ChangeBinStatusAction(status: string) {
    return {
        type: "@@InitBinListState/ChangeBinStatusAction" as const,
        status,
    };
}

export function ChangeBinHistoryAction(binHistoryList: BinHisoryList[]) {
    return {
        type: "@@InitBinListState/ChangeBinHistoryAction" as const,
        binHistoryList,
    };
}

export function ChangeSelectedZoneIdAction(zone_id:number){
    return {
        type: "@@InitBinListState/ChangeSelectedZoneIdAction" as const,
        zone_id,
    };
}

export function ChangeSelectedToiletNumberAction(toilet_number:string){
    return {
        type: "@@InitBinListState/ChangeSelectedToiletNumberAction" as const,
        toilet_number,
    }
}




export type BinListAction =
    | ReturnType<typeof InitBinListAction>
    | ReturnType<typeof InitBinDetailAction>
    | ReturnType<typeof ChangeBinNameAction>
    | ReturnType<typeof ChangeBinEngNameAction>
    | ReturnType<typeof ChangeBinEmailAction>
    | ReturnType<typeof ChangeBinContactPersonAction>
    | ReturnType<typeof ChangeBincCodeAction>
    | ReturnType<typeof ChangeBincLatAction>
    | ReturnType<typeof ChangeBincLonAction>
    | ReturnType<typeof ChangeBinRemarkAction>
    | ReturnType<typeof ChangeBinContractAction>
    | ReturnType<typeof ChangeDistrictIdAction>
    | ReturnType<typeof ClearSelectedBinAction>
    | ReturnType<typeof ChangeBinTypeAction>
    | ReturnType<typeof ChangeBinStatusAction>
    | ReturnType<typeof ChangeSelectedZoneIdAction>
    | ReturnType<typeof ChangeSelectedToiletNumberAction>
    | ReturnType<typeof ChangeBinHistoryAction>
    | ReturnType<typeof initBinGroupListAction>